import { Glucose } from "@cur8/health-risks-calc";
import { PathLink } from "@pomle/react-router-paths";
import { paths } from "render/routes/paths";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useGlucoseMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Metric, MetricLoading } from "../../layouts/Metric";
import { Trans } from "./trans";

export function MetricGlucose() {
  const { data, isLoading: isDataLoading } = useGlucoseMetric();

  if (isDataLoading) {
    return <MetricLoading label={<Trans.MetricName />} />;
  }

  if (!data) {
    return null;
  }

  const { cur, prev } = getMetricHistory(data);
  const riskRanges = Glucose.rangesFor();
  const metricRating = cur && riskRanges.findRisk(cur.unit);
  const value = cur?.unit["mmol/L"];
  const prevValue = prev?.unit["mmol/L"];

  return (
    <PathLink to={paths.glucoseMetric.url({})}>
      <Metric
        metricRating={metricRating}
        label={<Trans.MetricName />}
        value={value}
        subLabel={<Trans.MetricLabel />}
        previousValue={prevValue}
        showPreviousInsteadOfChange={true}
      />
    </PathLink>
  );
}
